import React, { Component } from "react";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { Trans, withTranslation } from "react-i18next";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import Button from "@material-ui/core/Button";
import FormGroup from "@material-ui/core/FormGroup";
import { DatePicker } from "@material-ui/pickers";
import CoreFilter from "./CoreFilter";
import moment from "moment";
import MomentUtils from "@date-io/moment";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import UserAutosuggest from "../UserAutosuggest";
import ListItem from "@material-ui/core/ListItem";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import Collapse from "@material-ui/core/Collapse";
import Table from "@material-ui/core/Table";
import { Badge } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/core/styles";
import ListItemText from "@material-ui/core/ListItemText";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@mdi/react";
import { mdiFilterVariantRemove, mdiFilterVariant } from "@mdi/js";
import InputLabel from "@material-ui/core/InputLabel";
import { connect } from "react-redux";
import UserTeamPicker from "../required-reading/UserTeamPicker";
import { taxServiceClient } from "../../AxiosClient";

const styles = (theme) => ({
  container: {},
  gridContainer: {
    alignItems: "center",
    flexGrow: 1,
  },
  gridItem: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    flexGrow: 1,
    minWidth: theme.spacing(24),
  },
  filterWrapper: {
    display: "flex",
    alignItems: "center",
    flexGrow: 1,
  },
  formControl: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    flexGrow: 1,
  },
  userPickerFormControl: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: "100%",
  },
  selectMargin: {
    marginTop: 16,
    marginLeft: 5,
    marginRight: 5,
    minWidth: 182,
  },
  userPickerWrapper: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: "100%",
  },
  completeContainer: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
});
const StyledBadge = withStyles((theme) => ({
  anchorOriginTopLeftRectangle: {
    transform: "translate(-150%, 50%)",
  },
  badge: {},
}))(Badge);
const equal = require("deep-equal");
const areObjectsEqual = (obj1, obj2) => {
  return equal(obj1, obj2) ? true : false;
};
export class FilterRequiredReading extends Component {
  constructor(props) {
    super(props);
    this.state = {
      documentTypes: [],
      defaultFilters: ["myCompleteFilter", "createdBy"],
      opened: false,
      createdBy: null,
    };
  }
  componentDidMount() {
    if (this.props.filter.createdBy && this.props.filter.createdBy.length > 0) {
      taxServiceClient
        .post("/user/userlist", { userIds: this.props.filter.createdBy })
        .then((res) => {
          this.setState({ createdBy: res.data });
        });
    }
  }
  componentDidUpdate(_prevProps, prevState) {
    if (
      !areObjectsEqual(this.props.filter.createdBy, _prevProps.filter.createdBy)
    ) {
      taxServiceClient
        .post("/user/userlist", { userIds: this.props.filter.createdBy })
        .then((res) => {
          this.setState({ createdBy: res.data });
        });
    }
  }

  toggleExpand = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState((prev) => ({ opened: !prev.opened }));
  };
  onCreatedByUpdate = (newUsers) => {
    let event = {};
    event.target = {};
    event.target.name = "createdBy";
    event.target.value = newUsers.map((u) => u.userId);
    this.props.handleChange(event);
  };
  render() {
    const { classes, t, expanded } = this.props;
    let filterObj = {};
    filterObj.sort = this.props.asPopper === true && (
      <div className={classes.sortByContainer}>
        <Typography className={classes.sortByLabel}>
          <Trans i18nKey="global_filter_sort_by" />
        </Typography>
        <FormControl className={classes.sortBy}>
          <Select
            value={this.props.filter.sort}
            onChange={this.props.handleSortChange}
            inputProps={{
              name: "sort",
              id: "sort",
            }}
          >
            <MenuItem value="none">
              <Trans i18nKey="filter_discussions_sort_none" />
            </MenuItem>
            <MenuItem value="createdDate">
              <Trans i18nKey="global_filter_created_date" />
            </MenuItem>
            <MenuItem value="expiryDate">
              <Trans i18nKey="expiry_date" />
            </MenuItem>
            <MenuItem value="title">
              <Trans i18nKey="global_title" />
            </MenuItem>
            <MenuItem value="description">
              <Trans i18nKey="required_reading_description" />
            </MenuItem>
          </Select>
        </FormControl>
        <Button onClick={this.props.toggleSortDirection}>
          {this.props.filter.sortDirection === "ASC" ? (
            <>
              <ArrowUpwardIcon />
              <Trans i18nKey="global_ascending" />
            </>
          ) : (
            <>
              <ArrowDownwardIcon />
              <Trans i18nKey="global_descending" />
            </>
          )}
        </Button>
      </div>
    );
    filterObj.myCompleteFilter = (
      <div className={classes.completeContainer}>
        <FormControl className={classes.formControl}>
          <InputLabel htmlFor="completed">
            <Trans i18nKey="filter_requiredreading_completion_status" />
          </InputLabel>
          <Select
            value={this.props.filter.myCompleteFilter}
            onChange={this.props.handleSelectChange}
            inputProps={{
              name: "myCompleteFilter",
              id: "myCompleteFilter",
            }}
          >
            <MenuItem value="Any">
              <Trans i18nKey="filter_discussions_all" />
            </MenuItem>
            <MenuItem value="Completed">
              <Trans i18nKey="manage_rr_percent_completed" />
            </MenuItem>
            <MenuItem value="Partial">
              <Trans i18nKey="filter_requiredreading_partially_completed_by_me" />
            </MenuItem>
            <MenuItem value="NotCompleted">
              <Trans i18nKey="filter_requiredreading_not_completed" />
            </MenuItem>
          </Select>
        </FormControl>
      </div>
    );
    filterObj.createdDateEnd = (
      <FormControl className={classes.formControl}>
        <DatePicker
          autoOk
          label={t("filter_documents_created_before")}
          clearable
          disableFuture
          value={
            this.props.filter.createdDateEnd
              ? moment(this.props.filter.createdDateEnd)
              : null
          }
          onChange={this.props.handleDateChange("createdDateEnd")}
        />
      </FormControl>
    );
    filterObj.createdDateStart = (
      <FormControl className={classes.formControl}>
        <DatePicker
          autoOk
          label={t("filter_documents_created_after")}
          clearable
          disableFuture
          value={
            this.props.filter.createdDateStart
              ? moment(this.props.filter.createdDateStart)
              : null
          }
          onChange={this.props.handleDateChange("createdDateStart")}
        />
      </FormControl>
    );
    filterObj.expiryDateEnd = (
      <FormControl className={classes.formControl}>
        <DatePicker
          autoOk
          label={t("filter_requiredreading_expiring_before")}
          clearable
          value={
            this.props.filter.expiryDateEnd
              ? moment(this.props.filter.expiryDateEnd)
              : null
          }
          onChange={this.props.handleDateChange("expiryDateEnd")}
        />
      </FormControl>
    );
    filterObj.expiryDateStart = (
      <FormControl className={classes.formControl}>
        <DatePicker
          autoOk
          label={t("filter_requiredreading_expiring_after")}
          clearable
          value={
            this.props.filter.expiryDateStart
              ? moment(this.props.filter.expiryDateStart)
              : null
          }
          onChange={this.props.handleDateChange("expiryDateStart")}
        />
      </FormControl>
    );

    filterObj.createdBy = (
      <FormControl className={classes.userPickerFormControl}>
        <UserTeamPicker
          usersOnly={true}
          onTeamUsersUpdate={this.onCreatedByUpdate}
          onUsersUpdate={this.onCreatedByUpdate}
          userHeaderKey=""
          userTeamHeaderKey="create_message_users_team_header"
          asChips
          loadUsers={this.state.createdBy}
          hideNoUsersMessage={true}
        />
      </FormControl>
    );

    const activeFilters = (
      <>
        {!this.state.opened &&
          Object.keys(this.props.filter)
            .filter((filter) => this.props.isFilterSet(filter))
            .map(
              (filter, idx) =>
                filterObj.hasOwnProperty(filter) &&
                this.state.defaultFilters.indexOf(filter) < 0 &&
                filterObj[filter] && (
                  <Grid
                    item
                    xs={filter === "createdBy" || filter === "myCompleteFilter" ? 12 : 6}
                    sm={filter === "createdBy" || filter === "myCompleteFilter" ? 6 : 3}
                    lg={filter === "createdBy" || filter === "myCompleteFilter" ? 6 : 2}
                    classes={{ root: classes.gridItem }}
                  >
                    {filterObj[filter]}
                  </Grid>
                )
            )}
      </>
    );
    const inActiveFilters = (
      <>
        {this.state.opened &&
          Object.keys(filterObj).map(
            (filter, idx) =>
              filterObj.hasOwnProperty(filter) &&
              this.state.defaultFilters.indexOf(filter) < 0 &&
              filterObj[filter] && (
                <Grid
                  item
                  xs={filter === "createdBy" || filter === "myCompleteFilter" ? 12 : 6}
                  sm={filter === "createdBy" || filter === "myCompleteFilter" ? 6 : 3}
                  lg={filter === "createdBy" || filter === "myCompleteFilter" ? 6 : 2}
                  classes={{ root: classes.gridItem }}
                >
                  {filterObj[filter]}
                </Grid>
              )
          )}
      </>
    );
    let defaultFilters = this.state.defaultFilters.map(
      (filter, idx) =>
        filterObj.hasOwnProperty(filter) &&
        filterObj[filter] && (
          <Grid
            item
            xs={filter === "createdBy" || filter === "myCompleteFilter" ? 12 : 6}
            sm={filter === "createdBy" || filter === "myCompleteFilter" ? 6 : 3}
            lg={filter === "createdBy" || filter === "myCompleteFilter" ? 6 : 2}
            classes={{ root: classes.gridItem }}
          >
            {filterObj[filter]}
          </Grid>
        )
    );
    return (
      <>
        {this.props.asPopper ? (
          <MuiPickersUtilsProvider utils={MomentUtils}>
            {this.props.filter !== null && (
              <div>
                {this.props.showReset && (
                  <Button
                    className={classes.resetButton}
                    onClick={this.props.resetToDefaultFilters}
                  >
                    <Trans i18nKey="filters_reset_to_default" />
                  </Button>
                )}
                <ExpansionPanel
                  expanded={expanded === "sort"}
                  onChange={this.props.handleExpansionPanelChange("sort")}
                >
                  <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography className={classes.heading}>
                      <Trans i18nKey="global_sort" />
                    </Typography>
                    <Typography className={classes.secondaryHeading}>
                      <Trans i18nKey="filter_documents_sort_secondary_heading" />
                    </Typography>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    {filterObj.sort}
                  </ExpansionPanelDetails>
                </ExpansionPanel>

                <ExpansionPanel
                  expanded={expanded === "completed"}
                  onChange={this.props.handleExpansionPanelChange("completed")}
                >
                  <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography className={classes.heading}>
                      <Trans i18nKey="manage_rr_percent_completed" />
                    </Typography>
                    <Typography className={classes.secondaryHeading}>
                      <Trans i18nKey="filter_requiredreading_completed_secondary_heading" />
                    </Typography>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    {filterObj.myCompleteFilter}
                  </ExpansionPanelDetails>
                </ExpansionPanel>
                <ExpansionPanel
                  expanded={expanded === "users"}
                  onChange={this.props.handleExpansionPanelChange("users")}
                >
                  <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography className={classes.heading}>
                      <Trans i18nKey="global_user_plural" />
                    </Typography>
                    <Typography className={classes.secondaryHeading}>
                      <Trans i18nKey="filter_requiredreading_users_secondary_heading" />
                    </Typography>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    {filterObj.createdBy}
                  </ExpansionPanelDetails>
                </ExpansionPanel>
                <ExpansionPanel
                  expanded={expanded === "dates"}
                  onChange={this.props.handleExpansionPanelChange("dates")}
                >
                  <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography className={classes.heading}>
                      <Trans i18nKey="global_sort_dates" />
                    </Typography>
                    <Typography className={classes.secondaryHeading}>
                      <Trans i18nKey="filter_requiredreading_dates_secondary_heading" />
                    </Typography>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    <div className={classes.datesContainer}>
                      <FormGroup row>
                        {filterObj.createdDateEnd}
                        {filterObj.createdDateStart}
                      </FormGroup>
                      <FormGroup row>
                        {filterObj.expiryDateEnd}
                        {filterObj.expiryDateStart}
                      </FormGroup>
                    </div>
                  </ExpansionPanelDetails>
                </ExpansionPanel>
              </div>
            )}
          </MuiPickersUtilsProvider>
        ) : (
          <div>
            <ListItem
              button
              onClick={(event) => event && event.stopPropagation()}
              className={classes.listItem}
              style={{
                paddingLeft: this.props.preText ? 0 : 10,
                borderRight: this.props.selected
                  ? `2px solid ${this.props.theme.palette.primary.main}`
                  : "",
              }}
              ContainerComponent="div"
              disableGutters={true}
              dense={true}
              selected={false}
            >
              {this.props.preText}
              <ListItemText
                primary={
                  <>
                    <div className={classes.filterWrapper}>
                      <span>
                        <IconButton
                          onClick={this.props.resetToDefaultFilters}
                          size="large"
                          color={
                            this.props.showReset === true
                              ? "secondary"
                              : "default"
                          }
                          disabled={this.props.showReset === false}
                        >
                          <Icon
                            path={
                              this.props.showReset === true
                                ? mdiFilterVariantRemove
                                : mdiFilterVariant
                            }
                            size={1.5}
                          />
                        </IconButton>
                      </span>
                      <div className={classes.filterWrapper}>
                        <Grid
                          container
                          classes={{ root: classes.gridContainer }}
                        >
                          {defaultFilters}
                          {activeFilters}
                          <Collapse
                            in={this.state.opened}
                            timeout="auto"
                            unmountOnExit
                          >
                            <Grid
                              container
                              classes={{ root: classes.gridContainer }}
                              style={{
                                display: this.props.isMobile && "contents",
                              }}
                            >
                              {inActiveFilters}
                            </Grid>
                          </Collapse>
                        </Grid>
                      </div>
                    </div>
                  </>
                }
                secondary={""}
              />
              {!this.props.hideExpand && (
                <IconButton onClick={this.toggleExpand}>
                  {this.state.opened ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </IconButton>
              )}
            </ListItem>
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  currentUser: state.user.currentUser,
  isMobile: state.screen.isMobile,
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withTranslation()(CoreFilter(FilterRequiredReading))));
